// extracted by mini-css-extract-plugin
export default {"root":"nBEsKQe6btirquvPaJNi","checkbox":"f9sp1HGuvVA7rTFgIgDR"};